import LocalStorage from '@/service/LocalStorage';

export const logout = (options?: { withRedirect?: boolean }) => {
  LocalStorage.clear();
  if (options?.withRedirect) {
    window.location.href = '/signin';
  }
};
